import { isString } from 'lodash';
import React, { useState } from 'react';
import { formatColor } from '@meitu/saas-colors';
import { checkLinearGradient } from '@meitu/saas-editor-core/es/utils/color-kit';
import { ColorGroup } from '@meitu/xdesign-widgets';

const SelectColor: React.FC<{
    defaultVal: string;
    dataSource: any;
    onComplete?: Function;
    isGradient?: boolean;
}> = React.memo(({ isGradient = false, defaultVal, dataSource, onComplete }) => {
    const [fill, setFill] = useState(isString(defaultVal) ? defaultVal : (formatColor(defaultVal) as string));
    return (
        <ColorGroup
            popupTriggerSize={{
                width: 78,
                height: 32,
            }}
            color={fill}
            setColor={(val: string) => {
                setFill(val);
                const isGradient = checkLinearGradient(val);
                const resColor = isGradient ? formatColor(val) : val;
                dataSource.color = resColor;
                onComplete?.();
            }}
            setColorAfter={(val, _, { isBrandColor }) => {
                if (isBrandColor) {
                    window._stat_track?.('hb_layers_func_use', {
                        func_id: '8_107',
                    });
                }
            }}
            isGradient={isGradient}
            onToggleBizTab={(bizTab) => {
                if (bizTab === 'team') {
                    window._stat_track?.('hb_layers_func_click', {
                        func_id: '8_107',
                    });
                }
            }}
        />
    );
});

export default SelectColor;
